import { isBefore } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

import { formatArrivalTime } from "./formatArrivalTime";

export function getArrivalTimeDescriptionLines(
  startDatetime: Date,
  workplaceTimezone: string
): string[] {
  const startDatetimeInTimezone = utcToZonedTime(startDatetime, workplaceTimezone);
  const nowInTimezone = utcToZonedTime(new Date(), workplaceTimezone);

  const hasStarted = isBefore(startDatetimeInTimezone, nowInTimezone);

  if (hasStarted) {
    return ["This shift has already started.", "Clock in as soon as you arrive."];
  }

  return [`This shift starts at ${formatArrivalTime(startDatetimeInTimezone)}.`];
}
